import script from "./BackButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=9ca23286&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca23286"]])

export default __exports__